import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import TopBar from "../../components/topBar";
import { getText } from "../../utils/util";
import CenterPage from "./components/centerPage";
import { useEffect, useState } from "react";
import { AcendexLayout } from "@/components/acendex/components/layout/AcendexLayout";

export default function JYJL() {
  const navigate = useNavigate();
  const { t: translate } = useTranslation();
  const [pledgeStatus,setPledgeStatus] = useState(0)

  useEffect(()=>{
    setPledgeStatus(Number(localStorage.getItem('pledgeStatus')))
  },[])
  return (
    <div className="w-full min-h-dvh bg-neutral-900 revert-style">
      <AcendexLayout
        theme="light"
        hideBottomBar
        mobileTopBarTitle={translate(getText("交易記錄"))}
        pcTopBarTitle={translate(getText("交易記錄"))}
      >
        <CenterPage pledgeStatus={pledgeStatus} />
      </AcendexLayout>
    </div>
  );
}
